import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { SearchSuggestionsResponse } from "@/lib/search/types";
const SUGGESTIONS_STALE_MS = 60_000;
export const searchSuggestionsQueryKey = (query: string) => ["search", "suggestions", query] as const;
async function fetchSearchSuggestions(query: string): Promise<SearchSuggestionsResponse> {
  const response = await fetch("/api/search/query", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      q: query
    })
  });
  if (!response.ok) {
    throw new Error(`search query ${response.status}`);
  }
  return response.json();
}
function suggestionsQueryOptions(query: string) {
  return {
    queryKey: searchSuggestionsQueryKey(query),
    queryFn: () => fetchSearchSuggestions(query),
    staleTime: SUGGESTIONS_STALE_MS
  };
}
export function useSearchSuggestions(query) {
  const $ = _c(5);
  let t0;
  if ($[0] !== query) {
    t0 = suggestionsQueryOptions(query);
    $[0] = query;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = query.length > 0;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      retry: 1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(t2);
}

// The /api/search/query request is what Typesense analytics counts. Submitting
// before the input debounce fires would otherwise never send the final query;
// prefetching reuses the cache, so a query already fetched isn't counted twice.
export function usePrefetchSearchSuggestions() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = query => queryClient.prefetchQuery(suggestionsQueryOptions(query));
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}